module.exports = __webpack_public_path__ + "static/media/tn_blog1.5c6d9bd6.png";